// export const environment = {
//   production: true,
//   apiEndpoint: 'http://localhost:8080',
//   loginEndpoint: 'http://localhost:8080',
//   logoutEndpoint: 'http://localhost:8080'
// };

export const environment = {
  production: true,
  acessoLink:  '',
  apiEndpoint: '',
  loginEndpoint: '',
  logoutEndpoint: '',
  ssoLink: 'https://sso.cfc.org.br',
  auth: {
    detailsUrl: "/api/user/details",
    loginUrl: "/api/login",
    logoutUrl: "/api/logout",
    userStorage: localStorage,
    userStorageIndex: "user"
  },
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts